import * as cnt from './constants';

const initialState = {
  channels: [],
  channelsFetching: false,
  channelsTitle: '',
  connections: [],
  connectionsFetching: false,
  conversations: [],
  partnerLocked: false,
  conversationsContractId: null,
  conversationsFetching: false,
  conversationsParticipantName: null,
  conversationsTitle: null,
  latestMessages: [],
  messageCreateError: false,
  messageCreating: false,
  pendingConnections: [],
  selectedChannel: null,
  selectedConnection: null,
  selectedContract: null,
  statusMessagesLoading: false,
  unreadAccepted: [],
};

export function workspace(state = initialState, { type, payload }) {
  switch (type) {
    case `${cnt.CONNECTIONS_FETCH}_STARTED`: {
      return Object.assign({}, state, { connectionsFetching: true });
    }
    case `${cnt.CHANGE_SELECTION}`: {
      payload.before = {
        connection: state.selectedConnection,
        channel: state.selectedChannel,
      };
      // update the lastChannel and lastContract in the store
      const newStore = {};
      if (payload.connection && payload.channel) {
        const selectedConnectionIx = state.connections.map(e => e.id).indexOf(payload.connection);
        const selectedChannelIx = state.channels.map(e => e.channelId).indexOf(payload.channel);
        if (selectedConnectionIx > -1 && // connection exists
          selectedChannelIx > -1) { // channel exists
          newStore.connections = state.connections;
          newStore.connections[selectedConnectionIx].lastChannel = payload.channel;
        }
      }
      return Object.assign({}, state, { selectedConnection: payload.connection, selectedChannel: payload.channel }, newStore);
    }
    case `${cnt.CONNECTIONS_FETCH}_SUCCESS`: {
      return Object.assign({}, state, { connectionsFetching: false, connections: payload.connections });
    }
    case `${cnt.CONNECTIONS_FETCH}_ERROR`: {
      return Object.assign({}, state, { connectionsFetching: false });
    }
    case `${cnt.CHANNELS_SELECT_SAVE}_SUCCESS`: {
      // we saved a Channel+Contract selection, the reponse should include
      // channel information that could not be included in the channel list
      const newStore = {};
      if (payload.channel && payload.channel.channelId) {
        if (state.channels.filter(e => (
            e.channelId === payload.channel.channelId
          )).length === 0) {
          // channel+contractId combo are not on the current channel list store
          newStore.channels = state.channels.concat([payload.channel]);
        }
        // update the connections with the lastChannel to the saved
        const connectionIx = state.connections.map(e => e.id).indexOf(state.selectedConnection);
        if (connectionIx > 0) {
          newStore.connections = state.connections;
          newStore.connections[connectionIx].lastChannel = payload.channel.channelId;
        }
      }
      return Object.assign({}, state, newStore);
    }
    case cnt.CONNECTIONS_ARCHIVE: {
      return Object.assign({}, state, { connections: state.connections.map(e => {
        if (e.id === payload) e.disabled = true;
        return e;
      }) });
    }
    case `${cnt.CHANNELS_FETCH}_STARTED`: {
      return Object.assign({}, state, { channelsFetching: true });
    }
    case `${cnt.CHANNELS_FETCH}_SUCCESS`: {
      const newStore = { channelsFetching: false,
        channels: payload.channels,
        channelsTitle: payload.title || '',
      };
      if (payload.newConnection && state.connections.map(e => e.id).indexOf(payload.newConnection.id) < 0) {
        // to prevent a race condition where both connections return a new
        // connection on the list and the channe list includes it in the return
        newStore.connections = state.connections.concat([payload.newConnection]);
      }
      return Object.assign({}, state, newStore);
    }
    case `${cnt.CHANNELS_FETCH}_ERROR`: {
      return Object.assign({}, state, { channelsFetching: false });
    }
    case cnt.CHANNELS_SELECT: {
      const selectedConnectionIndex = state.connections.map(e => e.id).indexOf(state.selectedConnection);
      const connections = (payload && selectedConnectionIndex > -1) ? state.connections.map((e, ix) => {
        if (ix === selectedConnectionIndex) e.lastChannel = payload;
        return e;
      }) : state.connections;
      return Object.assign({}, state, { selectedChannel: payload, connections });
    }
    case cnt.CHANNELS_RESET: {
      return Object.assign({}, state, { channels: [], channelsTitle: '' });
    }
    case `${cnt.CONVERSATIONS_FETCH}_STARTED`: {
      return Object.assign({}, state, { conversationsFetching: true });
    }
    case `${cnt.CONVERSATIONS_FETCH}_SUCCESS`: {
      return Object.assign({}, state, {
        conversationsFetching: false,
        partnerLocked: payload.partnerLocked,
        conversations: payload.conversations,
        conversationsTitle: payload.title,
        conversationsParticipantName: payload.recipientName,
        conversationsContractId: payload.contractId,
      });
    }
    case `${cnt.CONVERSATIONS_FETCH}_ERROR`: {
      return Object.assign({}, state, { conversationsFetching: false });
    }
    case cnt.CONVERSATIONS_RESET: {
      return Object.assign({}, state, { conversations: [], conversationsTitle: null });
    }
    case cnt.CHANNELS_ARCHIVE: {
      return Object.assign({}, state, { channels: state.channels.map(e => {
        if (e.channelId === payload.channel && e.contractId === payload.contract) e.disabled = true;
        return e;
      }) });
    }
    case cnt.MESSAGE_DISABLE: {
      const newConvs = state.conversations.map(e => {
        if (e.key === payload) e.disabled = true;
        return e;
      });
      return Object.assign({}, state, { conversations: newConvs });
    }
    case `${cnt.MESSAGE_CREATE}_STARTED`: {
      return Object.assign({}, state, { messageCreating: true, messageCreateError: false });
    }
    case `${cnt.MESSAGE_CREATE}_SUCCESS`: {
      return Object.assign({}, state, { messageCreating: false });
    }
    case `${cnt.MESSAGE_CREATE}_ERROR`: {
      return Object.assign({}, state, { messageCreating: false, messageCreateError: true });
    }
    case `${cnt.STATUS_MESSAGES}_STARTED`: {
      return Object.assign({}, state, { statusMessagesLoading: true });
    }
    case `${cnt.STATUS_MESSAGES}_ERROR`: {
      return Object.assign({}, state, { statusMessagesLoading: false });
    }
    case `${cnt.STATUS_MESSAGES}_SUCCESS`: {
      return Object.assign({}, state, {
        statusMessagesLoading: false,
        latestMessages: payload.latestMessages,
        pendingConnections: payload.pendingConnections,
        unreadAccepted: payload.unreadAccepted,
      });
    }
    case cnt.CONTRACT_SELECT: {
      const selectedConnectionIndex = state.connections.map(e => e.id).indexOf(state.selectedConnection);
      const connections = (selectedConnectionIndex > -1) ? state.connections.map((e, ix) => {
        if (ix === selectedConnectionIndex) e.lastContract = payload;
        return e;
      }) : state.connections;
      return Object.assign({}, state, { selectedContract: (payload || null), connections });
    }
    case cnt.STATUS_MESSAGES_REMOVE_CONNECTION: {
      return {
        ...state,
        pendingConnections: state.pendingConnections.filter(({ _id: id }) => id !== payload),
      };
    }
    case cnt.STATUS_CONNECTIONS_MARK_READ: {
      return {
        ...state,
        unreadAccepted: state.unreadAccepted.filter(({ connectionId }) =>
          payload.indexOf(connectionId) === -1,
        ),
      };
    }
    default:
      return state;
  }
}



// WEBPACK FOOTER //
// ./src/app/components/workspace/store/reducer.js